import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";

export const Header = ({ variant = "light" }) => {
  const { t, lang, setLang } = useI18n();
  const isDark = variant === "dark";
  return (
    <header
      data-testid="site-header"
      className={
        "sticky top-0 z-40 backdrop-blur-xl border-b " +
        (isDark
          ? "bg-[color:var(--impact-navy-950)]/70 border-white/10"
          : "bg-white/75 border-[color:var(--impact-border)]")
      }
    >
      <div className="max-w-[1400px] mx-auto flex items-center justify-between px-6 md:px-10 py-4">
        <Link to="/" data-testid="brand-home-link" className="flex items-center gap-3 group">
          <img
            src="/impact-digital-logo.png"
            alt="Impact Digital — Stratégie, visibilité, croissance"
            className="h-9 md:h-10 w-auto select-none"
            draggable="false"
          />
          <span className="hidden sm:inline eyebrow eyebrow-cyan ml-2 border-l border-[color:var(--impact-border)] pl-3">
            Impact Audit AI
          </span>
        </Link>
        <nav className="flex items-center gap-2 md:gap-4">
          <a
            data-testid="header-main-site-link"
            href="https://agenceimpactdigital.ca"
            target="_blank"
            rel="noreferrer"
            className={
              "hidden md:inline text-sm animated-underline " +
              (isDark ? "text-white/70 hover:text-white" : "text-[color:var(--impact-ink-2)] hover:text-[color:var(--impact-ink)]")
            }
          >
            {t("nav.backToSite")}
          </a>
          <button
            data-testid="lang-toggle-btn"
            aria-label={t("lang.switchTo")}
            onClick={() => setLang(lang === "fr" ? "en" : "fr")}
            className={
              "font-mono text-[11px] font-medium tracking-[0.18em] px-3 py-2 rounded-full border transition-colors " +
              (isDark
                ? "border-white/15 text-white/80 hover:bg-white/5"
                : "border-[color:var(--impact-border)] hover:bg-white")
            }
          >
            {lang === "fr" ? "EN" : "FR"}
          </button>
          <Link
            to="/admin/login"
            data-testid="header-admin-link"
            className={
              "hidden md:inline text-sm animated-underline " +
              (isDark ? "text-white/70 hover:text-white" : "text-[color:var(--impact-ink-2)] hover:text-[color:var(--impact-ink)]")
            }
          >
            {t("nav.admin")}
          </Link>
        </nav>
      </div>
    </header>
  );
};
